import * as contactpointList from './contactpointList';
import * as contactpointListByCity from './contactpointListByCity';
import * as contactpointItem from './ContactpointItem';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    contactpointList: contactpointList.IState
    contactpointListByCity: contactpointListByCity.IState
    contactpointItem: contactpointItem.IState
}

export const ActionCreators = {
    contactpointList: contactpointList.ActionCreators,
    contactpointListByCity: contactpointListByCity.ActionCreators,
    contactpointItem: contactpointItem.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    contactpointList: contactpointList.Reducers,
    contactpointListByCity: contactpointListByCity.Reducers,
    contactpointItem: contactpointItem.Reducers,
});

export function* sagas() {
    yield all([
        fork(contactpointList.sagas),
        fork(contactpointListByCity.sagas),
        fork(contactpointItem.sagas),
    ]);
}
